<template>
    <div
        ref="wrapper"
        class="cz2__ai-modal__upload"
    >
        <transition name="cz2__fade" mode="out-in">
            <base-loading-state
                v-if="isLoading || isBuilding"
                :heading="loadingHeading"
                :copy="loadingCopy"
            />

            <base-error-state
                v-else-if="aiUploadActiveState === aiUploadStates.error"
            />

            <base-review-state v-else-if="aiUploadActiveState === aiUploadStates.review" />
        </transition>
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    .cz2__ai-modal__upload {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        padding: 48px 24px 24px 24px;

        @include respond-above(lg) {
            padding: 24px;
        }
    }
</style>

<script>
    import { animate } from 'motion';

    import BaseLoadingState from './BaseLoadingState.vue';
    import BaseErrorState from './BaseErrorState.vue';
    import BaseReviewState from './BaseReviewState.vue';

    export default {
        components: {
            BaseLoadingState,
            BaseErrorState,
            BaseReviewState,
        },

        computed: {
            aiUploadActiveState() {
                return this.$store.state.aiUploadActiveState;
            },

            aiUploadStates() {
                return this.$store.state.aiUploadStates;
            },

            isLoading() {
                return this.aiUploadActiveState === this.aiUploadStates.loading;
            },

            isBuilding() {
                return this.aiUploadActiveState === this.aiUploadStates.building;
            },

            loadingHeading() {
                return this.isBuilding ? this.$t('AI_BUILDING_POP_HEADING') : this.$t('AI_LOADING_POP_HEADING');
            },

            loadingCopy() {
                return this.isBuilding ? this.$t('AI_BUILDING_POP_COPY') : this.$t('AI_LOADING_POP_COPY');
            },

            // Redefine what mobile means to accommodate special tablet styling
            isAiMobile() {
                return window.innerWidth < 640;
            },
        },

        mounted() {
            if (this.isAiMobile) {
                this.animateModal();
            }
        },

        methods: {
            animateModal() {
                animate(this.$refs.wrapper, {
                    transform: [
                        'translateY(100%)',
                        'translateY(0)',
                    ],
                }, {
                    duration: 0.35,
                    easing: 'ease-out',
                });
            },
        },
    };
</script>
